/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Dashboard
 *| (C) Copyright IBM Corp. 2017, 2021
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

define([
	'../../../../lib/@waca/core-client/js/core-client/ui/core/Class',
	'../../../../dataSources/utils/DatasourceUtil',
	'underscore'
], function (
	Class,
	DatasourceUtil,
	_
) {
	'use strict';

	/**
	 * @classdesc provides public APIs to access widget metaddata.
	 */
	var VisMetadataManager = Class.extend({

		/**
		 * @constructs
		 * @public
		 * @param {Object}  params - Mandatory: parameters to initialize the VisMetadataManager.
		 * @param {Object}  params.widgetModel - Mandatory.
		 */
		init: function (params) {
			VisMetadataManager.inherited('init', this, arguments);
			this.dashboardApi = params.dashboardApi;
			this.widgetModel = params.widgetModel;
			this.visualizationFeature = params.visualizationFeature;
			_.each(_.keys(params), function (key) {
				this[key] = params[key];
			}.bind(this));
		},

		getModule: function () {
			let module = null;
			const dataSource = this.visualizationFeature.getDataSource();
			if (dataSource) {
				const deprecatedDataSources = this.dashboardApi.getFeature('dataSources.deprecated');
				if (deprecatedDataSources) {
					let legacyDataSourcesCollection =  deprecatedDataSources.getSourcesCollection();
					const sourceModelAPI = legacyDataSourcesCollection.getSource(dataSource.getId());
					module = sourceModelAPI.getModuleAPI();
				}
			}
			return module;
		},

		getMetadataColumn: function (columnId, sourceId, logNotFound) {
			if (DatasourceUtil.isMultiMeasuresSeriesOrValue(columnId)) {
				return this._getMultiMeasuresSeriesMetadataColumn(columnId);
			}
			var module = this.getModule(sourceId);
			return module ? module.getMetadataColumn(columnId, logNotFound) : null;
		},

		_getMultiMeasuresSeriesMetadataColumn: function(columnId) {
			return {
				getId: function() { return columnId; },
				getType: function() { return 'attribute'; },
				isHidden: function(){return false;}
			};
		},

		/**
		 * Returns an array of metadataColumn object for each dataItem in the model
		 * @param  {string} optViewIdx Optional
		 * @return {[MetadataColumn]}
		 */
		getMetadataColumns: function () {
			var metadataColumns = [];
			if (this.widgetModel && this.widgetModel.get('data')) {
				var dataItems = this.widgetModel.get('data').getDataItemsOfAllViewsAsCollection();
				if (dataItems) {
					var module = this.getModule();
					if (module) {
						dataItems.forEach(function (dataItem) {
							if (!DatasourceUtil.isMultiMeasuresSeriesOrValue(dataItem.id)) {
								var metadataColumn = module.getMetadataColumn(dataItem.itemId);
								if (metadataColumn) {
									metadataColumns.push(metadataColumn);
								} else {
									metadataColumns.push({
										status: 'notFound',
										getId: function () {
											return dataItem.itemId;
										},
										getLabel: function () {
											return dataItem.itemLabel;
										},
										getSourceCategory: function() {
											return null;
										},
										isMissing: function() {
											return true;
										}
									});
								}
							}
						}.bind(this));
					}
				}
			}

			return metadataColumns;
		},

		destroy: function () {
			VisMetadataManager.inherited('destroy', this, arguments);
		}
	});

	return VisMetadataManager;
});
